module.exports = __webpack_public_path__ + "img/2_ar.8c402d8a.png";